import React, {Component} from 'react'

export default class FakeRegistration extends Component {
    render() {
        return(
            <div className="container-fluid">
                <div className="col-md-8 col-md-offset-2">
                    <a style={{display: 'block'}} className="cookie-btn" onClick={() => this.props.history.goBack()}>
                        <span className="glyphicon glyphicon-arrow-left">{}</span> <strong>TORNA INDIETRO</strong>
                    </a>
                    <h1>REGISTRAZIONE</h1>
                    <p>
                        Gentile utente,<br/>
                        a seguito dell’attivazione della nuova gestione del servizio di sosta a pagamento e conformemente a quanto previsto dalla recente normativa in materia di privacy, gli utenti che hanno intenzione di richiedere il permesso e/o l’abbonamento sosta sono tenuti ad effettuare la registrazione al nuovo servizio presentando la documentazione necessaria attestante il possesso dei requisiti previsti dal Regolamento.
                    </p>
                    <p>
                        La registrazione dovrà essere effettuata presso lo sportello TEMPOLIBERO del gestore affidatario, ubicato in Via Ferrucci n. 10, (XXIV Luglio – zona Piazza XXIV Luglio), aperto al pubblico nei seguenti giorni e orari:
                    </p>
                    <ul>
                        <li>da Lunedì a Venerdì, dalle ore 10.00 alle ore 16.30</li>
                        <li>Sabato dalle ore 9.30 alle ore 17.00</li>
                    </ul>
                    <p style={{textAlign: 'center'}}>
                        <a
                            href="https://www.tempolibero.city/wp-content/uploads/2019/02/modulo-F-registrazione1.pdf"
                            target="_blank"
                        >
                            <button className="splash-btn">MODULO DI REGISTRAZIONE ABBONATI</button>
                        </a>
                    </p>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Registration/FakeRegistration.js